import { Box, Card, Typography, Divider, CardContent, Grid, 
  Button, TextField, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import {useState, useEffect} from 'react';

import {useAuth} from "../../contexts/AuthContext"

import {handlerBy, validateAndProcessHolidays, validateExceptionalDays, validateReccurrentSchedule} from "../Utils"

import app from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { useHistory } from 'react-router-dom';
import RecurrentSchedule from './RecurrentSchedule';
import ExceptionalDays from './ExceptionalDays';
import SimpleSelect from '../SimpleSelect';

const db = app.firestore();

const arr = [...Array(20).keys()];
arr.push(116 - 1);
arr.push(270 - 1);
arr.push(680 - 1);
const parisZipOptions = arr.map(i => {
  const str = (75000 + i + 1).toString();
  return {label: str, value: str};
});

const parisCityOptions = [
  // 1ere zone
  { label: "Zone 1 - Paris", value: "Paris"},
  // { label: "Paris", value: "Paris"},
]

const zone2CityOptions = [
  // 2eme zone
  { label: "Zone 2 - Neuilly-sur-Seine", value: "Neuilly-sur-Seine"},
  { label: "Zone 2 - Levallois-Perret", value: "Levallois-Perret"},
  { label: "Zone 2 - Clichy", value: "Clichy"},
  { label: "Zone 2 - Saint-Ouen-sur-Seine", value: "Saint-Ouen-sur-Seine"},
  { label: "Zone 2 - Saint-Denis", value: "Saint-Denis"},
  { label: "Zone 2 - Aubervilliers", value: "Aubervilliers"},
  { label: "Zone 2 - Pantin", value: "Pantin"},
  { label: "Zone 2 - Le-Pre-Saint-Gervais", value: "Le-Pré-Saint-Gervais"},
  { label: "Zone 2 - Les-Lilas", value: "Les-Lilas"},
  { label: "Zone 2 - Bagnolet", value: "Bagnolet"},
  { label: "Zone 2 - Montreuil", value: "Montreuil"},
]


const zone3CityOptions = [
  // 3eme zone
  { label: "Zone 3 - Boulogne-Bilancourt", value: "Boulogne-Bilancourt"},
  { label: "Zone 3 - Puteaux", value: "Puteaux"}, 
  { label: "Zone 3 - Courbevoie", value: "Courbevoie"},
  { label: "Zone 3 - Asnières-sur-Seine", value: "Asnières-sur-Seine"},
  { label: "Zone 3 - Nanterre (la défense)", value: "Nanterre"},
  { label: "Zone 3 - La-Garenne-Colombes", value: "La-Garenne-Colombes"},
  { label: "Zone 3 - Bois-Colombes", value: "Bois-Colombes"},
  // { label: "Colombes", value: "Colombes"},
]

const zone2BCityOptions = [
  { label: "Zone 2B - Issy-les-Moulineaux", value: "Issy-les-Moulineaux"},
  { label: "Zone 2B - Vanves", value: "Vanves"},
  { label: "Zone 2B - Malakoff", value: "Malakoff"},
  { label: "Zone 2B - Montrouge", value: "Montrouge"},
  { label: "Zone 2B - Gentilly", value: "Gentilly"},
  { label: "Zone 2B - Le-Kremlin-Bicetre", value: "Le Kremlin Bicêtre"},
  { label: "Zone 2B - Ivry-sur-Seine", value: "Ivry-sur-Seine"},
  { label: "Zone 2B - Charenton-le-Pont", value: "Charenton-le-Pont"},
  { label: "Zone 2B - Saint-Mande", value: "Saint-Mandé"},
  { label: "Zone 2B - Vincennes", value: "Vincennes"},
]

const cityZips = {
  "Paris": "All75",
  "Boulogne-Bilancourt": "92100",
  "Neuilly-sur-Seine": "92200",
  "Levallois-Perret": "92300",
  "Clichy": "92110",
  // "Colombes": "92700",
  "Courbevoie": "92400",
  "Nanterre": "92000",
  "Saint-Ouen-sur-Seine": "93400",
  "Saint-Denis": "93200",
  "Aubervilliers": "93300",
  "Pantin": "93500",
  "Le-Pré-Saint-Gervais" : "93310",
  "Les-Lilas": "93260",
  "Bagnolet": "93170",
  "Montreuil": "93100",
  "Puteaux": "92800",
  "Asnières-sur-Seine": "92600",
  "La-Garenne-Colombes": "92250",
  "Bois-Colombes": "92270",

  "Issy-les-Moulineaux": "92130",
  "Vanves": "92170",
  "Malakoff": "92240",
  "Montrouge": "92120",
  "Gentilly": "94250",
  "Le-Kremlin-Bicetre": "94270",
  "Ivry-sur-Seine": "94200",
  "Charenton-le-Pont": "94220",
  "Saint-Mande": "94160",
  "Vincennes": "94300",
}

const weightOptions = [
  { label: "0 à 2 Kg", value: "2" },
  { label: "2 à 4 Kg", value: "4" },
  { label: "4 à 6 Kg", value: "6" },
  { label: "6 à 8 Kg", value: "8" },
  { label: "8 à 10 Kg", value: "10" },
  { label: "10 à 20 Kg", value: "20" },
  { label: "20 à 30 Kg", value: "30" },
  { label: "30 à 40 Kg", value: "40" },
  { label: "40 à 50 Kg", value: "50" },
  { label: "50 à 60 Kg", value: "60" },
  { label: "60 à 70 Kg", value: "70" },
]

export default function LocationCard({isUpdate, locationId, setLastRefreshDate, ...rest}) {
  const history = useHistory()

  const [name, setName] = useState("");

  const [cityOptions, setCityOptions] = useState(parisCityOptions, "cityOptions");
  const [cityZipOptions, setCityZipOptions] = useState(parisZipOptions, "cityZipOptions");
  const [city, setCity] = useState("Paris", "city");
  const [address, setAddress] = useState("");
  const [instructions, setInstructions] = useState("");
  const [zipCode, setZipCode] = useState("75001");

  const [firstName, setFirstName] = useState("");
  // const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");

  const [recurrentSchedule, setRecurrentSchedule] = useState({
    Monday: {
      morningStart: -1,
      morningEnd: -1,
      afternoonStart: -1,
      afternoonEnd: -1
    },
    Tuesday: {
      morningStart: -1,
      morningEnd: -1,
      afternoonStart: -1,
      afternoonEnd: -1
    },
    Wednesday: {
      morningStart: -1,
      morningEnd: -1,
      afternoonStart: -1,
      afternoonEnd: -1
    },
    Thursday: {
      morningStart: -1,
      morningEnd: -1,
      afternoonStart: -1,
      afternoonEnd: -1
    },
    Friday: {
      morningStart: -1,
      morningEnd: -1,
      afternoonStart: -1,
      afternoonEnd: -1
    },
    Saturday: {
      morningStart: -1,
      morningEnd: -1,
      afternoonStart: -1,
      afternoonEnd: -1
    },
    Sunday: {
      morningStart: -1,
      morningEnd: -1,
      afternoonStart: -1,
      afternoonEnd: -1
    },
  })

  const [holidays, setHolidays] = useState("");

  const [exceptionalDays, setExceptionalDays] = useState([]);

  const {retailerId, currentUser, retailerData} = useAuth();

  
  useEffect(() => {
    const zip = cityZips[city];
    if(zip == "All75") {
      setCityZipOptions(parisZipOptions);
      setZipCode("75001");
    } else {
      setCityZipOptions([{label: zip, value: zip}]);
      setZipCode(zip);
    }
  }, [city]) // => update zips

  useEffect(() => {
    
    let retailerCityOptions = parisCityOptions;
    if(retailerData.pickupCityPermissions) {
      if (retailerData.pickupCityPermissions.includes("zone2")){
        retailerCityOptions = retailerCityOptions.concat(zone2CityOptions)
      }
      if (retailerData.pickupCityPermissions.includes("zone2B")){
        retailerCityOptions = retailerCityOptions.concat(zone2BCityOptions)
      }
      if (retailerData.pickupCityPermissions.includes("zone3")){
        retailerCityOptions = retailerCityOptions.concat(zone3CityOptions)
      }
    }
    setCityOptions(retailerCityOptions);
    setCity("Paris");
    
  }, [retailerId]); // => update tsTypeOptions cityOptions then locations then locationIndex=0 


  useEffect( () => {
    const loadAndSetLocationLocations = async () => {
      if(!locationId) {
        return;
      }

      const locationRef = await db.collection('locations').doc(locationId).get();
      const location = locationRef.data();

      setName(location.name ?? "");
      
      setCity(location.address.city);
      setAddress(location.address.streetAddress);
      setInstructions(location.address.instructions??"");
      setZipCode(location.address.zipCode);

      setFirstName(location.contact.firstName);
      // setLastName(location.contact.lastName);
      setPhoneNumber(location.contact.phoneNumber);
      setEmail(location.contact.email);

      setRecurrentSchedule(location.recurrentSchedule);
      setHolidays(location.holidays);
      setExceptionalDays(location.exceptionalDays.map(e => ({
        morningStart: e.morningStart,
        morningEnd: e.morningEnd,
        afternoonStart: e.afternoonStart,
        afternoonEnd: e.afternoonEnd,
        day : new Date(e.day*1000)
      })));
    }
    
    loadAndSetLocationLocations();
  }, [locationId])

  // parts of this function and rest api should be transformed into a single trigger onCartUpdate to paid
  const handleConfirm = async () => {
    console.log("Add location started");

    try {
      const retailer = await db.collection('retailers').doc(retailerId).get();
      if (!retailer.exists) {
          throw new Error('retailer does not exists');
      }
      const retailerData = retailer.data();
    
      let pn = phoneNumber; 
      if (pn.startsWith("0")) {
        pn = "+33" + pn.substr(1);
      }

      let errorMessage = "La configuration est invalide";

      const processedSettings = {
        name,
        
        address : {
          streetAddress: address,
          zipCode,
          city: city,
          country: "FR",
          instructions
        },

        contact : {
          firstName,
          // lastName,
          phoneNumber: pn,
          email
        },

        exceptionalDays: exceptionalDays.map(e => ({
          morningStart: e.morningStart,
          morningEnd: e.morningEnd,
          afternoonStart: e.afternoonStart,
          afternoonEnd: e.afternoonEnd,
          day : e.day.getTime() / 1000
        })),

        holidays,

        recurrentSchedule
      }

      errorMessage = "La configuration des horaires récurrents est invalide";
      validateReccurrentSchedule(processedSettings.recurrentSchedule);

      errorMessage = "La configuration des jours fériés est invalide";
      processedSettings.processedHolidays = validateAndProcessHolidays(processedSettings.holidays);

      errorMessage = "La configuration des jours exceptionnels est invalide";
      validateExceptionalDays(processedSettings.exceptionalDays);

      errorMessage = "La soumission de la configuration a échoué";
      // await db.collection('locations').doc(retailerId).update({...processedSettings}); 

      if(isUpdate) {
        processedSettings.updatedBy = currentUser.email;
        await db.collection('locations').doc(locationId).update(processedSettings); 
        console.log(processedSettings);
      } else {
        processedSettings.creationDate = new Date();
        processedSettings.retailerId = retailerId; 

        processedSettings.createdBy = currentUser.email;
        processedSettings.updatedBy = currentUser.email;
        await db.collection('locations').add(processedSettings); 
        console.log(processedSettings);
      }
      
      // const {message, hasError} = data.error ? {message: data.error, hasError: true} :
      //   {message: "La configuration a été mise à jour", hasError: false};

      // this.setState({
      //   toastMessage: "La configuration a été mise à jour",
      //   toastHasError: false,
      //   toastIsActive: true
      // });

      history.push("/locations");

    } catch(e) {
      console.log("settings submitted exception was thrown");
      console.log(e.message);
      // this.setState({
      //   toastMessage: errorMessage,
      //   toastHasError: true,
      //   toastIsActive: true
      // });
    }    
  }

  return (
    <>      
      <form>
        <Card>
          <CardContent>
            <Grid container spacing={4} wrap="wrap">
              <Grid item sm={12} xs={12} >
                <Typography color="textPrimary" variant="h6">
                  Adresse et contact
                </Typography>
              </Grid>              
              <Grid item sm={6} xs={12} >
                <TextField
                  value={name}
                  onChange={handlerBy(setName)}
                  label="Nom de la boutique" 
                  required
                  type="text"
                  variant="outlined" 
                  fullWidth
                />
              </Grid>
              <Grid item sm={4} xs={12} >
                <SimpleSelect 
                  value={city}
                  onChange={handlerBy(setCity)}
                  label="Ville"
                  options={cityOptions}
                  // disabled
                  // disabled={cityOptions0.length==1}
                  required={true}
                />
              </Grid>
              <Grid item sm={2} xs={12} >
                <SimpleSelect 
                  value={zipCode}
                  onChange={handlerBy(setZipCode)}
                  label="Code postal"
                  options={cityZipOptions}
                  required
                />
              </Grid>
              <Grid item sm={6} xs={12} >
                <TextField
                  value={address}
                  onChange={handlerBy(setAddress)}
                  label="Numéro et nom de la rue" 
                  required
                  type="text"
                  variant="outlined" 
                  fullWidth
                />
              </Grid>
              <Grid item sm={6} xs={12} >
                <TextField
                  value={instructions}
                  onChange={handlerBy(setInstructions)}
                  label="Accès (ex: digicode, nom sur interphone)"
                  type="text"
                  variant="outlined" 
                  fullWidth
                />
              </Grid>
              <Grid item sm={6} xs={12} >
                <TextField
                  value={firstName}
                  onChange={handlerBy(setFirstName)}
                  label="Personne à contacter" 
                  required
                  type="text"
                  variant="outlined" 
                  fullWidth
                />
              </Grid>
              <Grid item sm={6} xs={12} >
                <TextField
                  value={phoneNumber}
                  onChange={handlerBy(setPhoneNumber)}
                  label="Téléphone" 
                  required
                  type="tel"
                  variant="outlined" 
                  fullWidth
                />
              </Grid>              
              {/* <Grid item sm={6} xs={12} >
                <TextField
                  value={email}
                  onChange={handlerBy(setEmail)}
                  label="Email" 
                  required
                  type="email"
                  variant="outlined" 
                  fullWidth
                />
              </Grid> */}
            </Grid>
          </CardContent>
          <Divider />
          <CardContent>
            <RecurrentSchedule recurrentSchedule={recurrentSchedule} setRecurrentSchedule={setRecurrentSchedule} />
          </CardContent>
          <Divider />
          <CardContent>
            <Grid container spacing={4} wrap="wrap">
              <Grid item sm={12} xs={12} >
                <Typography color="textPrimary" variant="h6">
                  Jours de fermeture
                </Typography>
                {/* <Typography color="textSecondary" variant="subtitle2">
                  L'adresse ou se présentent les coursier pour la collecte
                </Typography> */}
              </Grid>
              <Grid item sm={12} xs={12} >
                <TextField
                  value={holidays}
                  onChange={handlerBy(setHolidays)}
                  label="Liste des dates 'jj/mm' séparées par des virugues"
                  required
                  type="text"
                  variant="outlined" 
                  fullWidth
                />
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardContent>
            <ExceptionalDays exceptionalDays={exceptionalDays} setExceptionalDays={setExceptionalDays} />
          </CardContent>
          <Divider />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 3 }}>
            <Button color="primary" variant="outlined" onClick={() => history.push("/locations")}>
              Annuler
            </Button>
            <Box pr={2}>
            </Box>
            <Button color="primary" variant="contained" onClick={handleConfirm} 
              disabled={name.trim() == "" || address.trim() == "" ||firstName.trim() == "" || phoneNumber.trim() == ""}
            >  
              Confirmer
            </Button>
          </Box>
        </Card>
      </form>
    </>
  );
}
